import React from "react"
import { Link } from 'react-router-dom'

export default ({ onNav, className='' }) => {
  return <Link className={ className } to={ "/" } onClick={ onNav }> Current Dodone </Link>
}
